<div class="modal-body">
    <div class="row">
      <div class="col-12 d-flex justify-content-between align-items-center">
        <p class="header-text poppins">CREATE SCORER</p>
        <img src="assets/img/shared/close-icon.svg" class="close-icon pointer" alt="" (click)="close()">
      </div>
      <div class="col-12">
        <p class="sub-text poppins">Please enter details of players</p>
      </div>
    </div>
    <form [formGroup]="form">
			<div class="row">
        <div class="col-12">
          <mat-form-field appearance="outline" class="w-100">
            <input matInput formControlName="username">
            <mat-label>Username</mat-label>
          </mat-form-field>
        </div>
      </div>

      <div class="row mt-20">
        <div class="col-12">
          <mat-form-field appearance="outline" class="w-100">
            <input matInput formControlName="email">
            <mat-label>Email</mat-label>
          </mat-form-field>
        </div>
      </div>
      <div class="row mt-20">
        <div class="col-12">
          <mat-form-field appearance="outline" class="w-100">
            <input matInput formControlName="password" type="password">
            <mat-label>Password</mat-label>
          </mat-form-field>
        </div>
      </div>
      <div class="row mt-20">
        <div class="col-12">
          <mat-form-field appearance="outline" class="w-100">
            <input matInput formControlName="password_confirmation" type="password">
            <mat-label>Password Confirmation</mat-label>
          </mat-form-field>
        </div>
      </div>
      <div class="row mt-20">
        <div class="col-12">
          <mat-form-field appearance="outline" class="w-100">
            <input matInput formControlName="name">
            <mat-label>Scorer Name</mat-label>
          </mat-form-field>
        </div>
      </div>
      <div class="row mt-20">
				<div class="col-12">
					<mat-form-field appearance="outline">
						<mat-select formControlName="status">
							<mat-option value="active">Active</mat-option>
							<mat-option value="inactive">Inactive</mat-option>
						</mat-select>
						<mat-label>Status</mat-label>
					</mat-form-field>
				</div>
      </div>
      <div class="row mt-20">
        <div class="col-12">
					<mat-form-field appearance="outline">
						<mat-select placeholder="League Open" formControlName="official">
							<mat-option value="yes">Yes</mat-option>
							<mat-option value="no">No</mat-option>
						</mat-select>
						<mat-label>Official</mat-label>
					</mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-12 d-flex justify-content-center">
          <button class="btn submit poppins" type="button" (click)="confirm()" [disabled]="!form.valid">Submit</button>  
        </div>
      </div>
    </form>
  </div>